<template>
  <DashboardPage>
    <UserForm :id="route.params.id" />
  </DashboardPage>
</template>

<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue';

import UserForm from './components/UserForm.vue';
const route = useRoute()
</script>